import { render, staticRenderFns } from "./ChoixEtTma.vue?vue&type=template&id=d243472a&"
import script from "./ChoixEtTma.vue?vue&type=script&lang=js&"
export * from "./ChoixEtTma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports